import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store.js';

import Layout from '../Components/Layout/Layout.js';
import PageTitle from '../Components/PageTitle.js';
import { getCMSObject } from 'sg-ui-components';
import WinnersTable from '../Components/WinnersTable.js';

const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
};

const DrawResultPage = ({ user, config, cmsSourceFirebase, drawings, loading, actions }) => {
    const promotionId = useQuery().get('gameid') ?? 0;
    const drawId = useQuery().get('drawid') ?? 0;
    const view = useQuery().get('view') ?? 'approved';

    const [selectedDrawing, setSelectedDrawing] = useState(null);

    const page = {
        title: getCMSObject('data.microsite.general.drawingsAndWinners.pageInfo.pageTitle'),
        className: 'drawings',
    };

    useEffect(async () => {
        await actions.drawingActions.getDrawings({ promotion_id: promotionId, draw_date: drawId, view: view });
    }, []);

    useEffect(() => {
        const drawing = drawings?.drawings.filter((drawing) => drawing.draw_date == drawId)[0];
        setSelectedDrawing(drawing);
    }, [drawings]);

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <div className='page-info'>
                <PageTitle title='Winners' />
            </div>

            {loading.actions['getDrawings'] ? (
                <div className='loading-icon ellipses' />
            ) : (
                <div className='drawing-container'>{selectedDrawing ? <WinnersTable drawing={selectedDrawing} /> : <div>No draw result found.</div>}</div>
            )}
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawResultPage);
